import { Component, Input, OnInit } from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import { LookupService } from "src/app/shared/services/lookup.service";

@Component({
    selector: "action-required-comments",
    templateUrl: "./action-required-comments.component.html",
    styleUrls: ["./action-required-comments.component.scss"],
    standalone: false
})
export class ActionRequiredCommentsComponent implements OnInit {
  @Input() comments: any[] = [];

  constructor() {}

  ngOnInit(): void {}
}
